import { DialogService, GridAction } from '@eforall/dashboard';
import { AccTeamDialog, AccVentureDialog } from '../../../../../../../../ui/widget';
import { AcceleratorAreaService } from '../../../../../accelerator-area.service';
import { AccVenture } from '../acc-ventures-view.part';

export function getActions(dialog: DialogService, areaService: AcceleratorAreaService): GridAction<AccVenture>[] {

	const actions: GridAction<AccVenture>[] = [
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'View Venture Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialog.showCustom(AccVentureDialog, { data: { accVentureId: rows[0]!.accVentureId } }, 900, 700);
				await areaService.reloadData(); // TODO: optimize to reload only if changes were made
			}
		},
		{
			iconClass: 'fa-regular fa-file-lines',
			label: 'View Team Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialog.showCustom(AccTeamDialog, { data: { accTeamId: rows[0]!.accTeamId } }, 900, 900);
				await areaService.reloadData(); // TODO: optimize to avoid full reload if no changes
			}
		}
	];

	return actions;
}